import React from 'react';
import Parallax from '.';

function BackgroundMobile(props) {
    return (
        <div className="background_mobile">
            <Parallax id={"mbox1"} top={"500px"} left={"-50%"} rotate={"378deg"} factor={0.1} width={"620px"} height={"423px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox2"} top={"1200px"} left={"-5%"} rotate={"48deg"} factor={0.12} width={"620px"} height={"583px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox3"} top={"1700px"} left={"-20%"} rotate={"267deg"} factor={0.03} width={"545px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox4"} top={"200px"} left={"10%"} rotate={"98deg"} factor={0.15} width={"534px"} height={"643px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox5"} top={"700px"} left={"40%"} rotate={"123deg"} factor={0.02} width={"532px"} height={"639px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox6"} top={"2300px"} left={"-10%"} rotate={"2347deg"} factor={0.13} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox7"} top={"2900px"} left={"10%"} rotate={"27deg"} factor={0.05} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox8"} top={"4500px"} left={"0%"} rotate={"543deg"} factor={0.1} width={"523px"} height={"435px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox9"} top={"3800px"} left={"-60%"} rotate={"85deg"} factor={0.13} width={"634px"} height={"234px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox10"} top={"4000px"} left={"30%"} rotate={"3425deg"} factor={0.02} width={"634px"} height={"434px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox11"} top={"3100px"} left={"-10%"} rotate={"342deg"} factor={0.12} width={"534px"} height={"432px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox12"} top={"4700px"} left={"-70%"} rotate={"23deg"} factor={0.1} width={"433px"} height={"456px"}>
                <div className="box"></div>
            </Parallax>

            <Parallax id={"mbox21"} top={"5500px"} left={"-50%"} rotate={"378deg"} factor={0.1} width={"620px"} height={"423px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox22"} top={"6200px"} left={"-5%"} rotate={"48deg"} factor={0.12} width={"620px"} height={"583px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox23"} top={"6700px"} left={"-20%"} rotate={"267deg"} factor={0.03} width={"545px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox24"} top={"5200px"} left={"10%"} rotate={"98deg"} factor={0.15} width={"534px"} height={"643px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox25"} top={"5700px"} left={"40%"} rotate={"123deg"} factor={0.02} width={"532px"} height={"639px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox26"} top={"6300px"} left={"-10%"} rotate={"2347deg"} factor={0.13} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox27"} top={"7900px"} left={"10%"} rotate={"27deg"} factor={0.05} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox28"} top={"7500px"} left={"0%"} rotate={"543deg"} factor={0.1} width={"523px"} height={"435px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox29"} top={"8800px"} left={"-60%"} rotate={"85deg"} factor={0.13} width={"634px"} height={"234px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox210"} top={"7000px"} left={"30%"} rotate={"3425deg"} factor={0.02} width={"634px"} height={"434px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox211"} top={"8100px"} left={"-10%"} rotate={"342deg"} factor={0.12} width={"534px"} height={"432px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox212"} top={"9700px"} left={"-70%"} rotate={"23deg"} factor={0.1} width={"433px"} height={"456px"}>
                <div className="box"></div>
            </Parallax>

            <Parallax id={"mbox221"} top={"10500px"} left={"-50%"} rotate={"378deg"} factor={0.1} width={"620px"} height={"423px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox222"} top={"11200px"} left={"-5%"} rotate={"48deg"} factor={0.12} width={"620px"} height={"583px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox223"} top={"11700px"} left={"-20%"} rotate={"267deg"} factor={0.03} width={"545px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox224"} top={"12200px"} left={"10%"} rotate={"98deg"} factor={0.15} width={"534px"} height={"643px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox225"} top={"12700px"} left={"40%"} rotate={"123deg"} factor={0.02} width={"532px"} height={"639px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox226"} top={"13300px"} left={"-10%"} rotate={"2347deg"} factor={0.13} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox227"} top={"13900px"} left={"10%"} rotate={"27deg"} factor={0.05} width={"621px"} height={"443px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox228"} top={"15500px"} left={"0%"} rotate={"543deg"} factor={0.1} width={"523px"} height={"435px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox229"} top={"13800px"} left={"-60%"} rotate={"85deg"} factor={0.13} width={"634px"} height={"234px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox2210"} top={"14000px"} left={"30%"} rotate={"3425deg"} factor={0.02} width={"634px"} height={"434px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox2211"} top={"13100px"} left={"-10%"} rotate={"342deg"} factor={0.12} width={"534px"} height={"432px"}>
                <div className="box"></div>
            </Parallax>
            <Parallax id={"mbox2212"} top={"14700px"} left={"-70%"} rotate={"23deg"} factor={0.1} width={"433px"} height={"456px"}>
                <div className="box"></div>
            </Parallax>
        </div>
    );
}

export default BackgroundMobile;